module.exports = __webpack_public_path__ + "img/tiyan.49bd9f7f.jpg";